var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebinars({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8800_92330)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.125 14C5.125 9.09847 9.09847 5.125 14 5.125C18.9015 5.125 22.875 9.09847 22.875 14C22.875 18.9015 18.9015 22.875 14 22.875C9.09847 22.875 5.125 18.9015 5.125 14ZM14 2.875C7.85583 2.875 2.875 7.85583 2.875 14C2.875 20.1442 7.85583 25.125 14 25.125C20.1442 25.125 25.125 20.1442 25.125 14C25.125 7.85583 20.1442 2.875 14 2.875ZM12.6241 9.06394C12.2789 8.8338 11.835 8.81235 11.4692 9.00812C11.1034 9.20389 10.8751 9.58511 10.8751 10V18C10.8751 18.4149 11.1034 18.7961 11.4692 18.9919C11.835 19.1877 12.2789 19.1662 12.6241 18.9361L18.6241 14.9361C18.9371 14.7274 19.1251 14.3761 19.1251 14C19.1251 13.6239 18.9371 13.2726 18.6241 13.0639L12.6241 9.06394ZM15.9719 14L13.1251 15.8979V12.1021L15.9719 14Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8800_92330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebinars);
export default __webpack_public_path__ + "static/media/webinars.e529034b5e3841921a170bf7eb9390d3.svg";
export { ForwardRef as ReactComponent };